export default __webpack_public_path__ + "static/media/address.7721e078.png";